import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Navigate } from "react-router-dom";
export const AuthenticatedView = ({ dtResult, token = "", endpoint, internalUser }) => _jsx(GenericAuthenticatedIframe, { token: token, endpoint: endpoint });
export default AuthenticatedView;
class GenericAuthenticatedIframe extends React.Component {
    constructor(props) {
        super(props);
        this.isValidSession = async () => {
            try {
                const res = await fetch(`${window.location.origin}/Login/Status`);
                const result = await res.json();
                if (result.status === "AccountStatusOK") {
                    return true;
                }
                else {
                    this.setRedirect();
                    return false;
                }
            }
            catch (error) {
                this.setRedirect();
                return false;
            }
        };
        this.state = {
            externalUrl: props.endpoint,
            redirect: false
        };
    }
    setRedirect() {
        this.setState({
            redirect: true
        });
    }
    componentDidMount() {
        const that = this;
        window.checkSession = async function () {
            return await that.isValidSession();
        };
        window.addEventListener("message", async (event) => {
            switch (event.data) {
                case "checkSession":
                    if (event.source !== null) {
                        event.source.postMessage({ type: "checkSession", value: await window.checkSession() }, { targetOrigin: event.origin });
                    }
                    break;
                default:
                    break;
            }
        });
    }
    render() {
        this.isValidSession();
        if (this.state.redirect) {
            return _jsx(Navigate, { to: "/Logout" });
        }
        return (_jsx("div", { className: "stuff_container", children: _jsx("iframe", { title: "title", src: this.state.externalUrl, style: {
                    border: "none",
                    width: "100%",
                    maxWidth: "100%",
                    height: "calc(100vh - 3rem)"
                } }) }));
    }
}
//# sourceMappingURL=AuthenticatedView.js.map